var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-coupon-detail',{staticClass:"pt-coupon-detail__withData",attrs:{"couponDetail":_vm.couponDetail,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }